(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/my-receivers.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/my-receivers.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.MyReceivers = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.my_receivers(data);
    },
    regions: {
      receiverMyReceivers: '.js-receiver-my-receivers'
    },
    events: {
      'click .js-login': 'login'
    },
    modelEvents: {
      change: 'render'
    },
    tagName: 'div',
    className: 'my-receiver-wrapper',
    onRender: function() {
      this.getRegion('receiverMyReceivers').show(new svs.grassroots.views.MyReceiversList({
        collection: this.options.collection
      }));
    },
    login: function() {
      svs.components.customer_login.login();
      return false;
    }
  });
})(Backbone, _, svs);


 })(window);